import { post } from "aws-amplify/api";

export default async function generateSpeech(
  text,
  language = "hr-HR",
  voiceName = "hr-HR-GabrijelaNeural"
) {
  try {
    // Construct the REST operation to post the data to your API
    const restOperation = post({
      apiName: "learnserbianappRESTapi",
      path: "/requestVoice",
      options: {
        body: {
          text: text,
          language: language,
          voiceName: voiceName,
        },
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    return response.path;
  } catch (e) {
    console.log("POST call failed: ", JSON.parse(e.response.body));
    throw new Error("Failed to generate speech");
  }
}
